import api from '../../lib/api';
import { SurveyForm, SurveyFormPayload } from './types';

export const getSurveyForms = async (surveyId: string): Promise<SurveyForm[]> => {
  const { data } = await api.get<{ success: boolean; data: SurveyForm[] }>(`assessments/${surveyId}/forms`);
  return data.data;
};

export const createSurveyForm = async (surveyId: string, payload: SurveyFormPayload): Promise<SurveyForm> => {
  try {
    const { data } = await api.post<{ success: boolean; message: string; data: SurveyForm }>(
      `assessments/${surveyId}/forms`,
      payload
    );
    return data.data;
  } catch (error: any) {
    if (error?.response?.data?.message) {
      throw new Error(error.response.data.message);
    }
    if (error?.response?.data?.error) {
      throw new Error(error.response.data.error);
    }
    throw error;
  }
};

export const setActiveSurveyForm = async (surveyId: string, formId: string): Promise<SurveyForm> => {
  try {
    const { data } = await api.post<{ success: boolean; message: string; data: SurveyForm }>(
      `assessments/${surveyId}/forms/${formId}/set-active`
    );
    return data.data;
  } catch (error: any) {
    if (error?.response?.data?.message) {
      throw new Error(error.response.data.message);
    }
    throw error;
  }
};














